<template>
  <div class="box box-secondary">
    <div class="box-header with-border">
      <h3 class="box-title">
        <i class="fa fa-list mr-5"></i>
        Zalando Connected Retail
      </h3>
      <div class="box-tools pull-right">
        <div class="box-tools pull-right" title="Details">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
        </div>
      </div>
    </div>
    <div class="box-body">
      <div class="row">
        <div class="col-md-2 col-sm-12 col-xs-12 border-right">
          <div class="description-block">
            <span class="description-text">{{'orders' | translate}}:</span>
            <h4 class="no-margin">{{connectedRetail.orders}}</h4>
          </div>
        </div>
        <div class="col-md-2 col-sm-12 col-xs-12 border-right">
          <div class="description-block">
            <span class="description-text">{{'article' | translate}}:</span>
            <h4 class="no-margin">{{connectedRetail.articles}}</h4>
          </div>
        </div>
        <div class="col-md-2 col-sm-12 col-xs-12 border-right">
          <div class="description-block">
            <span class="description-text">Ø {{'order_avg' | translate}}:</span>
            <h4 class="no-margin">{{connectedRetail.earning | currency }}</h4>
          </div>
        </div>
        <div class="col-md-2 col-sm-12 col-xs-12 border-right">
          <div class="description-block">
            <span class="description-text">{{'returns' | translate}}:</span>
            <h4 class="no-margin">{{connectedRetail.returns}}</h4>
          </div>
        </div>
        <div class="col-md-2 col-sm-12 col-xs-12 border-right">
          <div class="description-block">
            <span class="description-text ">{{'total_amount' | translate}}:</span>
            <h4 class="no-margin">{{connectedRetail.total_amount | currency}}</h4>
          </div>
        </div>
        <div class="col-md-2 col-sm-12 col-xs-12">
          <div class="description-block">
            <span class="description-text">{{'return_rate' | translate}}:</span>
            <h4 class="no-margin">{{connectedRetail.return_percentage | percentage}}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['connectedRetail'],
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  watch: {
    connectedRetail () {
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/tools/ConnectedRetailComponent.vue